/* eslint-disable */
import { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import { Table, Tooltip } from "antd";
import AddVendor from "../../customers/vendors/addVendor";
import InvoiceHead from "./invoice-head";
import useInvoiceHook from "./useInvoice";
import { Link, useLocation } from "react-router-dom";
import { CURRENCY_SYMBOLS } from "./components/constant";
import api from "../../api/axios";
const InvoiceList = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentStatus = searchParams.get("status");
  const currentUser = window.CURRENT_USER;
  const [menu, setMenu] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [show, setShow] = useState(false);
  const [deleteKey, setDeleteKey] = useState();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvoicesWithParams = async ({
      customers_ids,
      createdOn,
    } = {}) => {
      const params = {};

      if (currentStatus) params.status = currentStatus;
      if (customers_ids?.length > 0)
        params.customer_ids = customers_ids.join(",");
      if (createdOn) params.createdOn = createdOn;

      try {
        const res = await api.get("invoice/list/", { params });
        return res.data;
      } catch (error) {
        console.error("Error fetching invoices:", error);
        return [];
      }
    };

    const loadInvoices = async () => {
      setLoading(true);
      const result = await fetchInvoicesWithParams({
        status: "paid",
        customers_ids:
          currentUser?.user_role === "customer"
            ? [currentUser?.customer_id]
            : [],
        createdOn: "2025-07-01",
      });
      setInvoices(result);
      setLoading(false);
    };

    loadInvoices();
  }, [currentStatus]);

  if (loading) return <div>Loading...</div>;

  const invoiceStatuses = [{ id: null, label: "All Invoice" }];
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const datasource = invoices;

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const columns = [
    {
      title: "Invoice ID",
      dataIndex: "invoice_number",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.invoice_number.localeCompare(b.invoice_number),
      render: (img, record) => (
        <Link to={`/invoice/${record.id}/invoice`} className="invoice-link">
          {record.invoice_number}
        </Link>
      ),
    },

    {
      title: "Created On",
      dataIndex: "created_on",
    },
    {
      title: "Invoice To",
      dataIndex: "Name",
      render: (img, record) => (
        <h2 className="table-avatar">
          {record?.customer?.user?.full_name} <span>{record.email}</span>
        </h2>
      ),
      // sorter: (a, b) => a.Name.length - b.Name.length,
    },
    {
      title: "Total Amount",
      dataIndex: "total_invoice_amount",
      render: (text, row) => {
        return (
          <span className="text">
            {window.COMPANY.currency_symbol}
            {row?.total_invoice_amount}
          </span>
        );
      },
    },
    {
      title: "Invoice Balance",
      dataIndex: "Balance",

      render: (text, row) => {
        return (
          <span className="text">
            {window.COMPANY.currency_symbol}
            {row?.balance_amount}
          </span>
        );
      },
    },

    {
      title: "Action",
      dataIndex: "Action",
      render: (val, row) => (
        <div
          className="text-end d-flex"
          style={{
            alignItems: "center",
          }}
        >
          <Tooltip title="Download Invoice">
            <a
              className=""
              href={`/invoice/${row.id}/download/`}
              target="_blank"
              rel="noreferrer"
              style={{
                marginRight: 10,
              }}
            >
              <i className="fas fa-download me-2"></i>
            </a>
          </Tooltip>
          <Tooltip title="View Invoice">
            <Link
              className=""
              to={`/invoice/${row.id}/invoice`}
              style={{
                marginRight: 10,
              }}
            >
              <i className="far fa-eye me-2" />
            </Link>
          </Tooltip>
          <Tooltip title="Edit Invoice">
            {currentUser?.user_role !== "customer" && (
              <Link
                className=""
                to={`/invoice/${row.id}/edit-invoice/`}
                style={{
                  marginRight: 10,
                }}
              >
                <i className="far fa-edit me-2" />
              </Link>
            )}
          </Tooltip>
          {currentUser?.user_role === "super_admin" && (
            <Link
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_modal"
              onClick={() => setDeleteKey(row.id)}
            >
              <i
                className="far fa-trash-alt me-2"
                style={{
                  color: "red",
                }}
              />
            </Link>
          )}
        </div>
      ),
      // sorter: (a, b) => a.Action.length - b.Action.length,
    },
  ];
  const handleDelete = async () => {
    console.log("Delete function called");
    try {
      const response = await api.delete(`invoice/${deleteKey}/delete/`);
      if (response.status === 200) {
        setInvoices(invoices.filter((invoice) => invoice.id !== deleteKey));
      }
    } catch (error) {
      console.error("Error deleting invoice:", error);
    }
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <InvoiceHead
              setShow={setShow}
              show={show}
              currentUser={currentUser}
            />
            <div className="card invoices-tabs-card">
              <div className="invoices-main-tabs">
                <div className="row align-items-center">
                  <div className="col-lg-12">
                    <div className="invoices-tabs">
                      <ul>
                        {invoiceStatuses?.map(({ id, label }) => {
                          const isActive =
                            currentStatus === String(id) ||
                            (!currentStatus && id === null);
                          const to =
                            id !== null ? `/invoice?status=${id}` : `/invoice`;
                          return (
                            <li
                              key={label}
                              style={{
                                display: "inline-block",
                                marginRight: "10px",
                              }}
                            >
                              <Link
                                to={to}
                                style={{
                                  borderBottom: isActive
                                    ? "2px solid #2563eb"
                                    : "2px solid transparent",
                                  color: isActive ? "#2563eb" : "#6b7280",
                                  fontWeight: isActive ? "bold" : "normal",
                                  textDecoration: "none",
                                  transition: "color 0.2s, border-bottom 0.2s",
                                }}
                              >
                                {label}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card-table">
                  <div className="card-body invoiceList">
                    <div className="table-responsive table-hover">
                      <Table
                        // pagination={{
                        //   total: datasource?.length,
                        //   showTotal: (total, range) =>
                        //     `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        //   // showSizeChanger: true,
                        //   onShowSizeChange: onShowSizeChange,
                        //   itemRender: itemRender,
                        // }}
                        // rowSelection={rowSelection |}
                        columns={columns}
                        dataSource={datasource}
                        rowKey={(record) => record.id}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Table */}
          </div>
        </div>
        {/* {currentUser?.user_role !== "customer" && (
          <AddVendor
            setShow={setShow}
            show={show}
            onApply={(filters) => {
              setFilters(filters);
            }}
          />
        )} */}
        <div
          className="modal custom-modal fade"
          id="delete_modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content">
              <div className="modal-body">
                <div className="form-header">
                  <h3>Delete Invoice</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div className="modal-btn delete-action">
                  <div className="row">
                    <div className="col-6">
                      <button
                        type="reset"
                        data-bs-dismiss="modal"
                        className="w-100 btn btn-danger "
                        style={{
                          background: "red",
                        }}
                        onClick={handleDelete}
                      >
                        Delete
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        type="submit"
                        data-bs-dismiss="modal"
                        className="w-100 btn btn-primary paid-cancel-btn"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceList;
